import React from 'react';
import SelectSearchVirtualize from './SelectSearchVirtal'
import {AutocompleteProps} from "@mui/material/Autocomplete/Autocomplete";
import Autocomplete from "@mui/material/Autocomplete";

const AutocompleteWrapperSearch = (props: AutocompleteProps<any,any,any,any,any>) => {
    if (props.options?.length > 100) {
        return <SelectSearchVirtualize {...props as any}/>
    }
    return (
        <Autocomplete  {...props}/>
    );
};

export default AutocompleteWrapperSearch;